import React, { memo } from 'react';
import { Card } from 'react-bootstrap';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect, useDispatch } from 'react-redux';
import { formatDate, numberFormat } from 'utils';

import { analComBigTransRequest } from 'containers/market/actions';
import { analComEventsRequest } from 'containers/market/actions';
import { makeGetAnalComBigTrans, makeGetAnalComEvents } from 'lib/selector';
import EventDetailModal from 'components/modal/market/eventDetail'

import * as _ from 'lodash';

import styled from 'styled-components';
import { _formatDate4 } from 'utils';

//#region styled
const StyledDivTable = styled.div`
  position: relative;

  table {
    position: relative;
  }

  table thead th {
    position: sticky;
    top: 0;
  }
  table.theme-light thead th {
    background: #666666;
  }

  table.theme-light.table-analysis tbody tr:nth-child(odd) td {
    background: #eeeeee;
  }
`;

const StyleLink = styled.a`
  font-weight: 500;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: var(--half_white);

  &:hover{
    color: #f0b90b !important;
    text-decoration: underline !important;
    text-decoration-color: #f0b90b !important;
  }
`;

//#endregion

function PanelEvents(props) {
  const [tabActive, setTabActive] = React.useState('GioiThieu');
  const [dataShow, setDataShow] = React.useState(null);

  const { symbol, analComEvents, analComBigTrans, t, lang, theme } = props;
  const dispatch = useDispatch();

  React.useEffect(() => {
    getStockEvents();
    getStockBigTrans();
  }, [symbol]);

  function getStockEvents() {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 2);
    console.log(formatDate(d, '-', 'ymd'));
    const params = { secCode: symbol, lang, startDate: formatDate(d, '-', 'ymd') };
    dispatch(analComEventsRequest(params));
  }

  function getStockBigTrans() {
    const params = { secCode: symbol, lang };
    dispatch(analComBigTransRequest(params));
  }

  function handleShowModal(record) {
    setDataShow(record)
  }

  console.log(analComEvents);

  return (
    <Card
      className="mt-2 w-100"
      style={{ height: 'calc(100vh - 185px)', background: '#020210', borderRadius: '8px' }}
    >
      <Card.Header className="d-flex py-0 pr-2 tabs-cash">
        <a
          className={'fz-14 ' + (tabActive === 'GioiThieu' ? 'active' : '')}
          style={{ padding: '8px 0' }}
          onClick={() => setTabActive('GioiThieu')}
        >
          {t('algo.ptcp.txt-Events')}
        </a>
        <a
          className={'fz-14 ' + (tabActive === 'ThongTinCoBan' ? 'active' : '')}
          style={{ padding: '8px 0' }}
          onClick={() => setTabActive('ThongTinCoBan')}
        >
          {t('algo.ptcp.txt-Insider-transactions')}
        </a>
      </Card.Header>
      <Card.Body className="p-0">
        <PerfectScrollbar style={{ height: 'calc(100% - 5px)' }}>
          <StyledDivTable>
            {tabActive === 'GioiThieu' && (
              <table className={"table table-borderless table-analysis theme-" + theme}>
                <thead>
                  <tr>
                    <th className="text-left">
                      {t('algo.ptcp.txt-Announced-date')}
                    </th>
                    <th className="text-left">
                      {t('algo.ptcp.txt-Description')}
                    </th>
                    <th className="text-left">{t('algo.ptcp.txt-Ex-date')}</th>
                    <th className="text-left">
                      {t('algo.ptcp.txt-Last-register-date')}
                    </th>
                    <th className="text-left">
                      {t('algo.ptcp.txt-Effective-date')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {analComEvents &&
                    _.isArray(analComEvents) &&
                    analComEvents.map((item, index) => (
                      <tr key={index} onClick={() => handleShowModal(item)}>
                        <td className="txt-content">
                          {item.tradeDate}
                        </td>
                        <td className="txt-content">
                          <StyleLink>
                            {item.title}
                          </StyleLink>
                        </td>
                        <td className={"text-left " + (item.exDate ? 'txt-content' : 'txt-nodata')}>
                          {item.exDate ?? '---'}
                        </td>
                        <td className={"text-left " + (item.lastRegDate ? 'txt-content' : 'txt-nodata')}>
                          {item.lastRegDate ?? '---'}
                        </td>
                        <td className={"text-left " + (item.effectiveDate ? 'txt-content' : 'txt-nodata')}>
                          {item.effectiveDate ?? '---'}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
            {tabActive === 'ThongTinCoBan' && (
              <table className={"table table-borderless table-analysis theme-" + theme}>
                <thead>
                  <tr>
                    <th className="text-left text-nowrap">
                      {t('algo.ptcp.txt-Trans-type')}
                    </th>
                    <th className="text-left text-nowrap">{t('algo.ptcp.txt-Notifier')}</th>
                    <th className="text-left text-nowrap">{t('algo.ptcp.txt-Position')}</th>
                    <th className="text-left text-nowrap">
                      {t('algo.ptcp.txt-Related-person')}
                    </th>
                    <th className="text-left text-nowrap">
                      {t('algo.ptcp.txt-Relationship')}
                    </th>
                    <th className="text-right text-nowrap">
                      {t('algo.ptcp.txt-Reg-quantity')}
                    </th>
                    <th className="text-right text-nowrap">
                      {t('algo.ptcp.txt-Real-quantity')}
                    </th>
                    <th className="text-right text-nowrap">
                      {t('algo.ptcp.txt-Held-quantity')}
                    </th>
                    <th className="text-right text-nowrap">
                      {t('algo.ptcp.txt-Start-date')}
                    </th>
                    <th className="text-right text-nowrap">
                      {t('algo.ptcp.txt-End-date')}
                    </th>
                    <th className="text-right text-nowrap">{t('algo.ptcp.txt-Status')}</th>
                  </tr>
                </thead>
                <tbody>
                  {analComBigTrans &&
                    _.isArray(analComBigTrans) &&
                    analComBigTrans.map((item, index) => (
                      <tr key={index}>
                        <td
                          className={
                            'txt-content ' +
                            (item.TRANS_TYPE === 'Mua' ? 'i' : 'd')
                          }
                        >
                          {lang === 'vi' ? item.TRANS_TYPE : item.TRANS_TYPE_EN}
                        </td>

                        <td className="txt-content">
                          {lang === 'vi' ? item.NOTIFIER : item.NOTIFIER_EN}
                        </td>
                        <td className="txt-content">
                          {lang === 'vi'
                            ? item.NOTIFIER_POSITION
                            : item.NOTIFIER_POSITION_EN}
                        </td>
                        <td className="txt-content">
                          {lang === 'vi'
                            ? item.RELATED_PERSON
                            : item.RELATED_PERSON_EN}
                        </td>
                        <td className="txt-content">
                          {lang === 'vi'
                            ? item.RELATIONSHIP
                            : item.RELATIONSHIP_EN}
                        </td>
                        <td className="txt-content text-right">
                          {item.REG_QUANTITY === '-' ? item.REG_QUANTITY : numberFormat(item.REG_QUANTITY, 0, '0')}
                        </td>
                        <td className="txt-content text-right">
                          {item.REAL_QUANTITY === '-' ? item.REAL_QUANTITY : numberFormat(item.REAL_QUANTITY, 0, '0')}
                        </td>
                        <td className="txt-content text-right">
                          {item.AFTER_HELD_QUANTITY === '-' ? item.AFTER_HELD_QUANTITY : numberFormat(item.AFTER_HELD_QUANTITY, 0, '0')}
                        </td>
                        <td className="txt-content text-right">
                          {_formatDate4(item.START_DATE)}
                        </td>
                        <td className="txt-content text-right">
                          {_formatDate4(item.END_DATE)}
                        </td>
                        <td className="txt-content text-right  text-nowrap">
                          {lang === 'vi' ? item.STATUS : item.STATUS_EN}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
          </StyledDivTable>
        </PerfectScrollbar>
      </Card.Body>
      {
        dataShow && <EventDetailModal 
          onClose={() => setDataShow(null)}
          theme={theme}
          data={dataShow}
          t={t}
        />
      }
    </Card>
  );
}

const makeMapStateToProps = () => {
  const getAnalComEvents = makeGetAnalComEvents();
  const getAnalComBigTrans = makeGetAnalComBigTrans();

  const mapStateToProps = (state) => {
    return {
      analComEvents: getAnalComEvents(state),
      analComBigTrans: getAnalComBigTrans(state),
      lang: state.client?.setting?.lang || 'vi',
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(memo(PanelEvents));
